import { render, staticRenderFns } from "./ProfileSectionHistory.vue?vue&type=template&id=9a6ab654&scoped=true"
import script from "./ProfileSectionHistory.vue?vue&type=script&lang=js"
export * from "./ProfileSectionHistory.vue?vue&type=script&lang=js"
import style0 from "./ProfileSectionHistory.vue?vue&type=style&index=0&id=9a6ab654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6ab654",
  null
  
)

export default component.exports